import { createFileRoute, redirect } from '@tanstack/react-router'
import type { ReactNode } from 'react'

import { isSuccess } from '@orus.eu/result'

import { LoginPage } from '#/components/pages/login/login-page.tsx'
import { PendingSubscriptionPageSkeleton } from '#/modules/subscription/front-office/pending-subscription-page/pending-subscription-page-skeleton.tsx'
import { PendingSubscriptionPage } from '#/modules/subscription/front-office/pending-subscription-page/pending-subscription-page.tsx'
import { frontOfficeQueryOptions } from '#/shared/front-office-query-options.ts'

export const Route = createFileRoute('/')({
  beforeLoad: async ({ context }) => {
    const sessionResult = await context.session.getSessionResult()
    // SessionProvider owns the failure UI; neither the loader nor the screen should query in that state.
    if (!isSuccess(sessionResult)) return { canLoadPendingSubscription: false }
    const session = sessionResult.output
    if (session.user) {
      switch (session.permissions.type) {
        case 'client':
          throw redirect({ to: '/home' })
        case 'partner':
        case 'platform':
          throw redirect({ to: '/bo' })
      }
    }

    return { canLoadPendingSubscription: true }
  },
  loader: async ({ context }) => {
    if (!context.canLoadPendingSubscription) return
    await context.queryClient.ensureQueryData(
      context.trpc.subscriptions.getPendingSubscriptionId.queryOptions(undefined, frontOfficeQueryOptions),
    )
  },
  pendingComponent: PendingSubscriptionPageSkeleton,
  pendingMs: 150,
  component: HomeEntryPage,
})

function HomeEntryPage(): ReactNode {
  const { canLoadPendingSubscription } = Route.useRouteContext()
  if (!canLoadPendingSubscription) return null

  return (
    <PendingSubscriptionPage>
      <LoginPage />
    </PendingSubscriptionPage>
  )
}
